import React from 'react';

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">SOLUCIÓN EMPRESARIAL COMPLETA</div>
          <h1 className="hero-title">
            Sistema Completo de<br />
            <span className="hero-highlight">Gestión Empresarial</span>
          </h1>
          <p className="hero-description">
            Solución todo-en-uno para gestión de facturas, facturación electrónica, 
            operaciones POS, control de inventario y cumplimiento normativo colombiano.
          </p>
          <div className="hero-buttons">
            <a 
              href="https://wa.me/573123456789?text=Hola,%20me%20interesa%20solicitar%20una%20demo%20de%20APOLOX,%20el%20sistema%20completo%20de%20gestión%20empresarial.%20¿Podrían%20ayudarme?" 
              className="btn-primary"
            >
              Solicitar Demo
            </a>
            <a href="#demo" className="btn-secondary">Ver Demo</a>
          </div>
        </div>
        <div className="hero-visual">
          <img src="/componentes-mockup/logo apolox.png" alt="APOLOX Logo" style={{maxWidth: '60%', height: 'auto'}} />
        </div>
      </div>
    </section>
  );
};

export default Hero;